import { ApplicationsAnalyticsRoutes } from '../analytics/applications-analytics-routes';
import { ApplicationAddressBookRoutes } from './address-book/application-address-book-routes';
import { ApplicationAuthorizationRoutes } from './authorization/application-authorization-routes';
import { ApplicationBudgetsRoutes } from './budgets/application-budgets-routes';
import { ApplicationsCatalogueRoutes } from './catalogue/applications-catalogue-routes';
import { ApplicationsConstraintsRoutes } from './constraints/applications-constraints-routes';
import { ApplicationHardwareRoutes } from './hardware/applications-hardware-routes';
import { ApplicationsLaundryRoutes } from './laundry/applications-laundry-routes';
import { ApplicationLendingRoutes } from './lending/application-lending-routes';
import { ApplicationManageOrganizationRoutes } from './manage-organization/application-manage-organization-routes';
import { ApplicationManageUsersRoutes } from './manage-users/application-manage-users-routes';
import { ApplicationsMonitoringRoutes } from './monitoring/applications-monitoring-routes';
import { ApplicationsMyRoutes } from './my/applications-my-routes';
import { ApplicationsNivalizRoutes } from './nivaliz/application-nivaliz-routes';
import { ApplicationsNotificationsRoutes } from './notifications/applications-notifications-routes';
import { ApplicationsPudoRoutes } from './pudo/applications-pudo-routes';
import { ApplicationsRequirementsRoutes } from './requirements/applications-requirements-routes';
import { ApplicationsShopRoutes } from './shop/applications-shop-routes';
import { ApplicationsSpotsRoutes } from './spots/applications-spots-routes';
import { useApplicationFunctionalities } from './use-application-functionalities';
import { ApplicationVendingRoutes } from './vending/application-vending-routes';

export function ApplicationsRoutes() {
    const functionalities = useApplicationFunctionalities();

    const applicationsPudoRoutes = ApplicationsPudoRoutes(functionalities);
    const applicationsNivalizRoutes = ApplicationsNivalizRoutes(functionalities);
    const applicationsLaundryRoutes = ApplicationsLaundryRoutes(functionalities);
    const applicationsMyRoutes = ApplicationsMyRoutes();
    const applicationsManageUsersRoutes = ApplicationManageUsersRoutes();
    const applicationsManageOrganizationRoutes = ApplicationManageOrganizationRoutes();
    const applicationsAuthorizationRoutes = ApplicationAuthorizationRoutes();
    const applicationsAddressBookRoutes = ApplicationAddressBookRoutes();
    const applicationsVendingRoutes = ApplicationVendingRoutes(functionalities);
    const applicationsLendingRoutes = ApplicationLendingRoutes(functionalities);
    const applicationsHardwareRoutes = ApplicationHardwareRoutes();
    const applicationsNotificationsRoutes = ApplicationsNotificationsRoutes();
    const applicationsAnalyticsRoutes = ApplicationsAnalyticsRoutes();
    const applicationsCatalogueRoutes = ApplicationsCatalogueRoutes();
    const applicationsSpotsRoutes = ApplicationsSpotsRoutes();
    const applicationsMonitoringRoutes = ApplicationsMonitoringRoutes();
    const applicationsConstraintsRoutes = ApplicationsConstraintsRoutes();
    const applicationsRequirementsRoutes = ApplicationsRequirementsRoutes();
    const applicationsShopRoutes = ApplicationsShopRoutes(functionalities);
    const applicationsBudgetsRoutes = ApplicationBudgetsRoutes();
    return (
        <>
            {applicationsPudoRoutes}
            {applicationsNivalizRoutes}
            {applicationsLaundryRoutes}
            {applicationsMyRoutes}
            {applicationsManageUsersRoutes}
            {applicationsManageOrganizationRoutes}
            {applicationsAuthorizationRoutes}
            {applicationsAddressBookRoutes}
            {applicationsVendingRoutes}
            {applicationsLendingRoutes}
            {applicationsHardwareRoutes}
            {applicationsNotificationsRoutes}
            {applicationsAnalyticsRoutes}
            {applicationsCatalogueRoutes}
            {applicationsSpotsRoutes}
            {applicationsMonitoringRoutes}
            {applicationsConstraintsRoutes}
            {applicationsRequirementsRoutes}
            {applicationsShopRoutes}
            {applicationsBudgetsRoutes}
        </>
    );
}
